import EventCardList from '../components/EventCardList';
import Map from '../components/Map';
import { useSearchFields } from '../SearchFieldProvider';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { categoryLabels, mediaLabels } from '../constants';

export default function SearchResults({ events }) {
    const { filter } = useSearchFields();
    const [categorySelected, setCategorySelected] = useState([]);
    const handleCategoryChange = (selected) => {
        setCategorySelected(selected);
    };
    const [mediumSelected, setMediumSelected] = useState([]);
    const handleMediumChange = (selected) => {
        setMediumSelected(selected);
    };
    
    let eventsResultFiltered = [];
    const [eventsToPass, setEventsToPass] = useState(events);

    useEffect(() => {
        setEventsToPass(filter(events));
        setCategorySelected([]);
        setMediumSelected([]);
    //eslint-disable-next-line
    }, [filter])

    function haveCommonItems(arr1, arr2) {
        const set1 = new Set(arr1);
        const commonItems = arr2.filter(item => set1.has(item));
        return commonItems.length > 0;
    }

    function returnCommonItems(event, eventCategories, inputCategories) {
        // return event if eventCategories and inputCategories have common items 
        if (haveCommonItems(eventCategories, inputCategories)) {
            return event;
        }
        return;
    }

    const isCategoryOrMediumPresent = (event) => {
        // takes an event and returns true if it has any of the categories or media selected by the user 
        // if both filters are being used, check that all that match category also match any of the media 

        const catInput = [];
        const medInput = [];
        categorySelected.forEach((element) => catInput.push(element.value));
        mediumSelected.forEach((element) => medInput.push(element.value));

        const eventCategories = [];
        const eventMedia = [];

        // if just categories
        if (medInput.length === 0) {
            event.category.forEach((element) => eventCategories.push(element.name));
            const catMatch = haveCommonItems(catInput, eventCategories);
            return catMatch;
        }
        // if just media 
        if (catInput.length === 0) {
            event.medium.forEach((element) => eventMedia.push(element.name));
            const medMatch = haveCommonItems(medInput, eventMedia);
            return medMatch;
        }
        // if both 
        if (catInput.length > 0 && medInput.length > 0) {
            event.category.forEach((element) => eventCategories.push(element.name));
            // if the event has any of the category inputs, return the whole event. 
            const eventIfHasCategory = returnCommonItems(event, eventCategories, catInput);
            
            // check if it has any of the media inputs. 
            if (eventIfHasCategory) {
                event.medium.forEach((element) => eventMedia.push(element.name));
                return haveCommonItems(eventMedia, medInput)
            };      
        }        
    };

    const applyFilters = () => {
        if (categorySelected.length === 0 && mediumSelected.length === 0) {
            setEventsToPass(filter(events));
        } else {
            eventsResultFiltered = eventsToPass.filter((event) => isCategoryOrMediumPresent(event) === true);
            setEventsToPass(eventsResultFiltered);
        }
    };

    const listOrError = () => {
        if (eventsToPass.length > 0) {
            return (
                <div className="row">
                    <div className="col">
                        <EventCardList events={eventsToPass}/>
                    </div>
                    <div className="col d-none d-md-block h-100">
                        <Map events={eventsToPass} zoom={11} height={"100vh"}/>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="row py-3">
                    <h4>No events matched your search :/</h4>
                </div>
            );
        }
    };

    return (
        <div className="container py-3" id="results">
            <div className="row pb-3">
                    <div className="col-auto">
                        <Select
                            isClearable={true}
                            closeMenuOnSelect={true}
                            isMulti
                            name="Category"
                            placeholder="Category"
                            options={categoryLabels}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={handleCategoryChange}
                            value={categorySelected}
                            styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderRadius: 20,
                                }),
                              }}
                        />
                    </div>
                    <div className="col-auto">
                        <Select
                            isClearable={true}
                            closeMenuOnSelect={true}
                            isMulti
                            name="Medium"
                            placeholder="Medium"
                            options={mediaLabels}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={handleMediumChange}
                            value={mediumSelected}
                            styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderRadius: 20,
                                }),
                              }}
                        />
                    </div>
                    <div className='col-1'>
                        <button id="white-button" type="button" className="btn btn-lg" onClick={applyFilters}>FILTER</button>
                    </div>
                    
            </div>
           {listOrError()}
        </div>
    );
}